import styled from "@emotion/styled";

export const BreadcrumbContainer = styled.div`
  display: flex;
  place-items: center;
  gap: var(--gap, ${({ theme }) => theme.space.space4});
  padding-block: ${({ theme }) => theme.space.space4};

  svg {
    fill: var(--color, ${({ theme }) => theme.colors.tone.anthraciteLight});
  }
`;

export const BreadcrumbItem = styled.div`
  display: flex;
  min-height: ${({ theme }) => theme.fontSizes.fontSize20};
  font-size: var(--fontSize, ${({ theme }) => theme.fontSizes.fontSize14});
  color: var(--color, ${({ theme }) => theme.colors.tone.anthraciteLight});

  a {
    color: var(--color, ${({ theme }) => theme.colors.tone.anthraciteLight});

    &:hover {
      color: ${({ theme }) => theme.colors.tone.black};
    }
  }
`;
